import cls from "classnames";
import TagAndPerks from "./TagAndPerks";
import JoinButton from "./JoinButton";
import UserAvatar from "@qoohoo/common/components/UserAvatar";
import Coupon from "../coupon/Coupon";
import MembershipDurationLabel from "../MembershipDurationLabel";
import SuperCheckoutJoinButton from "./SuperCheckoutJoinButton";
import { enableNewCheckoutForFeature } from "constants/constants";

export const LimitedSeatsRibbon = ({ seatStatus, isMobile }) => {
  return !!seatStatus ? (
    <div
      className={cls(
        isMobile && "md:hidden",
        "absolute top-3 left-0 md:left-[-4px] right-0 md:right-[-4px] text-center bg-[#E17335] text-white text-sm font-semibold font-nunito p-[2px] banner-clip"
      )}
    >
      {seatStatus}
    </div>
  ) : null;
};

const Join = ({
  channelDetails,
  isCreator,
  isCoCreator,
  userChannelDetail,
  handleButtonClick,
  isLoading = false,
  seatStatus,
  isChannelEnded,
  areFewSeatsLeft,
  areSeatsFull,
  prepareCouponResponse,
  onCouponValidation,
  couponState,
  couponDiscount,
  showCouponField,
  showJoinButton,
  showSuperCheckoutButton,
  showMembershipDurationLabel,
  channelFee,
  userData,
  customConfig={}
}) => {
  const isSubscribed = userChannelDetail.is_channel_member;

  const isChannelArchived = channelDetails.is_archived;

  const isFreeChannel = channelDetails.type.toLowerCase() === "free_subscription";

  function renderButtons() {
    let joinButton;
    const enableNewCheckout = enableNewCheckoutForFeature.regular_channel;

    if(!showJoinButton) return;
    
    if(enableNewCheckout && showSuperCheckoutButton) {
      joinButton = (
        <SuperCheckoutJoinButton
          channelDetails={channelDetails}
          userChannelDetail={userChannelDetail}
          ctaButton={
            userChannelDetail?.cta_button ?? channelDetails?.cta_button
          }
          fullWidth={true}
          isLoading={isLoading}
          isCreator={isCreator}
          isCoCreator={isCoCreator}
          isDisabled={areSeatsFull}
          couponDiscount={couponDiscount}
          channelFee={channelFee}
          userData={userData}
          customConfig={customConfig}
        />
      )
    } else {
      joinButton = (<>
      {showCouponField && (
        <Coupon
          variant={Coupon.VARIANTS.inputFirst}
          state={couponState}
          prepareResponse={prepareCouponResponse}
          onValidation={onCouponValidation}
          className="mb-4"
        />
      )}
      {showJoinButton && (
        <JoinButton
          channelDetails={channelDetails}
          userChannelDetail={userChannelDetail}
          ctaButton={
            userChannelDetail?.cta_button ?? channelDetails?.cta_button
          }
          handleButtonClick={handleButtonClick}
          fullWidth={true}
          isLoading={isLoading}
          isCreator={isCreator}
          isCoCreator={isCoCreator}
          isDisabled={areSeatsFull}
          couponDiscount={couponDiscount}
          channelFee={channelFee}
        />
      )}
      </>)
    }
    return joinButton;
  }

  return (
    <div className={cls("flex flex-col items-center p-8 mb-6 rounded-2xl bg-[#22272B] relative", showMembershipDurationLabel && "!pt-6")}>
      <MembershipDurationLabel isHeaderMode={false} isVisible={showMembershipDurationLabel} link={()=>handleButtonClick(false)} linkLabel="Go to channel" userChannelDetail={userChannelDetail} colFormat={true}/>
      <LimitedSeatsRibbon seatStatus={seatStatus} />
      <div
        className={cls(
          "w-28 h-28 rounded-2xl overflow-hidden text-5xl uppercase font-bold flex justify-center items-center bg-[#2E353A]",
          { "mt-5": !!seatStatus }
        )}
      >
        <UserAvatar
          avatarUrl={channelDetails.center_image?.url}
          alt={channelDetails.name}
          userName={channelDetails.name}
        />
      </div>

      <h2 className="mt-5 text-lg font-bold text-center font-inter mb-4">
        {channelDetails.name}
      </h2>

      {renderButtons()}

      <hr className="w-full bg-white opacity-[0.07] mt-6" />

      <div className="flex items-center justify-between w-full mt-6">
        <div className="flex items-center gap-3 min-w-0 pr-[1px]">
          <div className="w-10 h-10 rounded-full overflow-hidden text-2xl uppercase font-bold flex justify-center items-center bg-[#2E353A] flex-shrink-0">
            <UserAvatar
              avatarUrl={channelDetails.creator.avatar?.url}
              alt={channelDetails.creator?.username}
              userName={channelDetails.creator?.username}
            />
          </div>
          <h4 className="text-sm font-semibold text-ellipsis overflow-hidden">
            {channelDetails.creator?.fullname}
          </h4>
        </div>
        <a
          target="_blank"
          href={`/by/${channelDetails.creator?.username}`}
          className={cls(
            "rounded-full text-xs font-semibold font-inter py-[0.375rem] px-3 hover:opacity-90 text-white border border-white/50 hover:bg-white hover:text-[#1B1B1E] transition-colors duration-300 md:max-w-none outline-none focus:outline-none flex-shrink-0"
          )}
        >
          View Profile
        </a>
      </div>
      <TagAndPerks channelDetails={channelDetails} />
    </div>
  );
};

export default Join;
